import type { FaireProductEntity } from "../../entity_types/product";

export const p_ue539fnbcd: FaireProductEntity = {
  token: "p_ue539fnbcd",
  type: "product",
  name: "Printed Canvas Tote Bag-Women's Travel Plush Shoulder Bag",
  brandToken: "b_3fb7o7n9vq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/99f28c2df764e1dc16155855d511a1e6dc9718b5a0fba9b7345576aa60a79e32.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70e6fed96c67dc19075ce0ade680a634cde1f9c2c7c0a985130ca87fa5dd52a9.jpeg",
    "https://cdn.faire.com/fastly/a7ebb05644ffbf26708fe1bebfb25f127bdca90db57f383af3c530a1d1f6b83e.jpeg",
    "https://cdn.faire.com/fastly/92a8eeb82baf129dd8920e4b62ba3fc04a9dc6446c52dd24e85d271f86d7798f.jpeg",
    "https://cdn.faire.com/fastly/6b160e9d28131771f3ac45c866ceca1702f8b0fbe715ca37ab12e942600dae3e.jpeg",
    "https://cdn.faire.com/fastly/b199778a838b7547d2999d722121ee2dcc3fcd4b3d6d95f3cc7b00d2fc6b3645.jpeg",
    "https://cdn.faire.com/fastly/891fcfb98fa23d9883f1cb44dcf2d60439e78f32fd4315d14f04ff76cb7a3f65.jpeg",
    "https://cdn.faire.com/fastly/b3aacd9dc79a4c22decd5189ed791e7034c9fc7881203296cdb9b21eeeeae139.jpeg",
    "https://cdn.faire.com/fastly/002df26abedefd20842b11492d5ab0176ef25f2a500e596ca4faec72c8b9336d.jpeg",
    "https://cdn.faire.com/fastly/896ab965c660cc056f194ac48077bc9c8ab61f2c715f788070e3a020cf7c2168.jpeg",
    "https://cdn.faire.com/fastly/997814a20b7e41a0db41e76b832c4a10c32ee2c3d523fbcd521d3aaa4f744583.jpeg",
    "https://cdn.faire.com/fastly/df83bdb7b94e07d5e02b5c07f905e82329bbda4e4234ceec451c2e3d6f31d1bc.jpeg",
    "https://cdn.faire.com/fastly/358d0869b32b2c8ac21f834b2a74b2703f035b17fe7a1d0df05003b290c78471.jpeg",
    "https://cdn.faire.com/fastly/f7d116ada9d893c9ad257721329f6c2ab254ba76243f9df5016699991864bae9.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "Material and Texture：Crafted from high - quality canvas with a corduroy finish, the bag offers a soft touch. The corduroy features plump and round ridges, is wear - resistant, thick, and provides good warmth - keeping properties.\n\nCapacity and Structure\nMedium - sized with an oval bottom for ample space. It has an inner phone pocket and an inner patch pocket, keeping your essentials organized.\n\nClosure and Hardware\nEquipped with a magnetic snap closure for easy opening and closing. The snap is rust - resistant even when wet, ensuring long - lasting use and security.\n\nShoulder Straps\nReinforced double - shoulder straps are strong, resistant to breakage, and designed for comfort, preventing shoulder strain during use.\n\nStyle and Color Options\nDesigned with a fresh and sweet aesthetic, it comes in 8 color schemes, making it a perfect match for basic outfits.",
  tags: [],
  msrpDollars: 16.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:39.074Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
